import { createRouter, createWebHistory } from 'vue-router';
import NProgress from '@/config/nprogress';
import ThaliScreen from '@/views/screen/thali/index.vue';
import RateScreen from '@/views/screen/rate/index.vue';
import SchoolScreen from '@/views/screen/campus/school.vue';
import SchoolOnlyScreen from '@/views/screen/campus/school-only.vue';
import WeekLocalPreview from '@/views/screen/week/preview.vue';

const routes = [
    {
        path: '/',
        name: 'login',
        component: () =>
            import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    },
    {
        path: '/main',
        name: 'main',
        component: () =>
            import(/* webpackChunkName: "init" */ '@/layouts/index.vue'),
        redirect: '/main/home',
        children: [
            {
                path: 'home',
                name: 'home',
                icon: 'icon-a-zu4484',
                code: 'home',
                component: () =>
                    import(
                        /* webpackChunkName: "init" */ '@/views/home/index.vue'
                    ),
                meta: {
                    name: '首页',
                    isHome: true,
                },
            },
            {
                path: 'week',
                name: 'week',
                icon: 'icon-a-zu4488',
                code: 'Management:WeeklyMenuMade',
                meta: {
                    name: '周食谱制作',
                },
                children: [
                    {
                        path: 'week-local',
                        name: 'week-local',
                        code: 'Management:WeeklyMenuMade:SelfMadeWeeklyMenu',
                        component: () =>
                            import(
                                /* webpackChunkName: "week" */ '@/views/week/local/index.vue'
                            ),
                        meta: {
                            name: '自制食谱',
                        },
                    },
                    {
                        path: 'week-cloud',
                        name: 'week-cloud',
                        code: 'Management:WeeklyMenuMade:CloudWeeklyMenu',
                        component: () =>
                            import(
                                /* webpackChunkName: "week" */ '@/views/week/cloud/index.vue'
                            ),
                        meta: {
                            name: '云食谱库',
                            keepAlive: true,
                        },
                    },
                    {
                        path: 'week-config',
                        name: 'week-config',
                        code: 'Management:WeeklyMenuMade:AnalysisConfig',
                        component: () =>
                            import(
                                /* webpackChunkName: "week" */ '@/views/week/config/index.vue'
                            ),
                        meta: {
                            name: '分析配置',
                        },
                    },
                ],
            },
            {
                path: 'thali',
                name: 'thali',
                icon: 'icon-a-zu4487',
                code: 'Management:SetMealMade',
                meta: {
                    name: '套餐制作',
                },
                children: [
                    {
                        path: 'thali-local',
                        name: 'thali-local',
                        code: 'Management:SetMealMade:SelfMadeSetMeal',
                        component: () =>
                            import(
                                /* webpackChunkName: "thali" */ '@/views/thali/local-thali/index.vue'
                            ),
                        meta: {
                            name: '自制套餐',
                        },
                    },
                    {
                        path: 'thali-cloud',
                        name: 'thali-cloud',
                        code: 'Management:SetMealMade:CloudSetMeal',
                        component: () =>
                            import(
                                /* webpackChunkName: "thali" */ '@/views/thali/cloud/index.vue'
                            ),
                        meta: {
                            name: '云套餐库',
                        },
                    },
                    {
                        path: 'thali-label',
                        name: 'thali-label',
                        code: 'Management:SetMealMade:SetMealLabel',
                        component: () =>
                            import(
                                /* webpackChunkName: "thali" */ '@/views/thali/label/index.vue'
                            ),
                        meta: {
                            name: '套餐标签',
                        },
                    },
                ],
            },
            {
                path: 'counter',
                name: 'counter',
                icon: 'icon-a-zu4489',
                code: 'Management:NutritionCalculator',
                meta: {
                    name: '营养计算器',
                },
                children: [
                    {
                        path: 'config',
                        name: 'config',
                        code: 'Management:NutritionCalculator:NutritionRecommendConfig',
                        component: () =>
                            import(
                                /* webpackChunkName: "counter" */ '@/views/counter/config-list/index.vue'
                            ),
                        meta: {
                            name: '营养推荐量配置',
                        },
                    },
                    {
                        path: 'component',
                        name: 'component',
                        code: 'Management:NutritionCalculator:NutritionIngredientCalculator',
                        component: () =>
                            import(
                                /* webpackChunkName: "counter" */ '@/views/counter/component.vue'
                            ),
                        meta: {
                            name: '营养成分计算器',
                        },
                    },
                    {
                        path: 'comprehensive',
                        name: 'comprehensive',
                        code: 'Management:NutritionCalculator:ComprehensiveCalculator',
                        component: () =>
                            import(
                                /* webpackChunkName: "counter" */ '@/views/counter/comprehensive.vue'
                            ),
                        meta: {
                            name: '综合计算器',
                        },
                    },
                ],
            },
            {
                path: 'cookbook',
                name: 'cookbook',
                icon: 'icon-a-zu4486',
                code: 'Management:Recipe',
                meta: {
                    name: '菜谱库',
                },
                children: [
                    {
                        path: 'cookbook-local',
                        name: 'cookbook-local',
                        code: 'Management:Recipe:SelfMadeRecipe',
                        component: () =>
                            import(
                                /* webpackChunkName: "cookbook" */ '@/views/cookbook/local-cookbook/index.vue'
                            ),
                        meta: {
                            name: '自制菜谱',
                        },
                    },
                    {
                        path: 'cookbook-cloud',
                        name: 'cookbook-cloud',
                        code: 'Management:Recipe:CloudRecipe',
                        component: () =>
                            import(
                                /* webpackChunkName: "cookbook" */ '@/views/cookbook/cloud/index.vue'
                            ),
                        meta: {
                            name: '云菜谱',
                        },
                    },
                    {
                        path: 'cookbook-category',
                        name: 'cookbook-category',
                        code: 'Management:Recipe:RecipeCategory',
                        component: () =>
                            import(
                                /* webpackChunkName: "cookbook" */ '@/views/cookbook/category/index.vue'
                            ),
                        meta: {
                            name: '菜谱分类',
                        },
                    },
                    {
                        path: 'cookbook-label',
                        name: 'cookbook-label',
                        code: 'Management:Recipe:RecipeLabel',
                        component: () =>
                            import(
                                /* webpackChunkName: "cookbook" */ '@/views/cookbook/label/index.vue'
                            ),
                        meta: {
                            name: '菜谱标签',
                        },
                    },
                ],
            },
            {
                path: 'goods-manage',
                name: 'goods-manage',
                icon: 'icon-a-zu4485',
                code: 'Management:Goods',
                meta: {
                    name: '商品库',
                },
                children: [
                    {
                        path: 'localGoods',
                        name: 'localGoods',
                        code: 'Management:Goods:GoodsArchives',
                        component: () =>
                            import(
                                /* webpackChunkName: "goods" */ '@/views/goods-manage/local-goods/index.vue'
                            ),
                        meta: {
                            name: '商品档案',
                        },
                    },
                    {
                        path: 'goods',
                        name: 'goods',
                        code: 'Management:Goods:CloudGoods',
                        component: () =>
                            import(
                                /* webpackChunkName: "goods" */ '@/views/goods-manage/goods/index.vue'
                            ),
                        meta: {
                            name: '云商品库',
                        },
                    },
                    {
                        path: 'meterage-category',
                        name: 'meterage-category',
                        code: 'Management:Goods:GoodsCategory',
                        component: () =>
                            import(
                                /* webpackChunkName: "goods" */ '@/views/goods-manage/category/index.vue'
                            ),
                        meta: {
                            name: '商品分类',
                        },
                    },
                    {
                        path: 'meterage-unit',
                        name: 'meterage-unit',
                        code: 'Management:Goods:MeteringUnit',
                        component: () =>
                            import(
                                /* webpackChunkName: "goods" */ '@/views/goods-manage/unit/index.vue'
                            ),
                        meta: {
                            name: '计量单位',
                        },
                    },
                    {
                        path: 'brand',
                        name: 'brand',
                        code: 'Management:Goods:BrandManage',
                        component: () =>
                            import(
                                /* webpackChunkName: "goods" */ '@/views/goods-manage/brand/index.vue'
                            ),
                        meta: {
                            name: '品牌管理',
                        },
                    },
                ],
            },
            {
                path: 'inventory',
                name: 'inventory',
                icon: 'icon-a-zu4479',
                code: 'Management:Inventory',
                meta: {
                    name: '出入库台账',
                },
                children: [
                    {
                        path: 'entry',
                        name: 'entry',
                        code: 'Management:Inventory:EntryManage',
                        component: () =>
                            import(
                                /* webpackChunkName: "inventory" */ '@/views/inventory/entry/index.vue'
                            ),
                        meta: {
                            name: '入库管理',
                        },
                    },
                    {
                        path: 'out',
                        name: 'out',
                        code: 'Management:Inventory:OutManage',
                        component: () =>
                            import(
                                /* webpackChunkName: "inventory" */ '@/views/inventory/out/index.vue'
                            ),
                        meta: {
                            name: '出库管理',
                        },
                    },
                    {
                        path: 'check',
                        name: 'check',
                        code: 'Management:Inventory:InventoryCheck',
                        component: () =>
                            import(
                                /* webpackChunkName: "inventory" */ '@/views/inventory/check/index.vue'
                            ),
                        meta: {
                            name: '库存盘点',
                        },
                    },
                    {
                        path: 'comprehensive-query',
                        name: 'comprehensive-query',
                        code: 'Management:Inventory:ComprehensiveQuery',
                        component: () =>
                            import(
                                /* webpackChunkName: "inventory" */ '@/views/inventory/comprehensive-query/index.vue'
                            ),
                        meta: {
                            name: '综合查询',
                        },
                    },
                    {
                        path: 'history-query',
                        name: 'history-query',
                        code: 'Management:Inventory:HistoryQuery',
                        component: () =>
                            import(
                                /* webpackChunkName: "inventory" */ '@/views/inventory/history-query/index.vue'
                            ),
                        meta: {
                            name: '历史查询',
                        },
                    },
                ],
            },
            {
                path: 'science-popularization',
                name: 'science-popularization',
                icon: 'icon-a-zu4321',
                code: 'Management:SciencePopularization',
                component: () =>
                    import(
                        /* webpackChunkName: "science" */ '@/views/science-popularization/index.vue'
                    ),
                meta: {
                    name: '科普管理',
                },
            },
            {
                path: 'science-preview',
                name: 'science-preview',
                icon: 'icon-a-zu4321',
                code: 'Management:SciencePopularizationShow',
                meta: {
                    name: '食育科普',
                },
                children: [
                    {
                        path: 'science-index/:id*',
                        name: 'science-index',
                        hiddenMenu: true,
                        component: () =>
                            import(
                                /* webpackChunkName: "science" */ '@/views/science-preview/index.vue'
                            ),
                        meta: {
                            name: '',
                        },
                    },
                ],
            },
            {
                path: 'system-manage',
                name: 'system-manage',
                icon: 'icon-a-zu4686',
                code: 'Management:SystemManage',
                meta: {
                    name: '系统管理',
                },
                children: [
                    {
                        path: 'unit',
                        name: 'unit',
                        code: 'Management:SystemManage:UnitManage',
                        component: () =>
                            import(
                                /* webpackChunkName: "system" */ '@/views/system-manage/unit/index.vue'
                            ),
                        meta: {
                            name: '单位管理',
                        },
                    },
                    {
                        path: 'user',
                        name: 'user',
                        code: 'Management:SystemManage:UserManage',
                        component: () =>
                            import(
                                /* webpackChunkName: "system" */ '@/views/system-manage/user/index.vue'
                            ),
                        meta: {
                            name: '用户管理',
                        },
                    },
                    {
                        path: 'dict',
                        name: 'dict',
                        code: 'Management:SystemManage:DataDict',
                        component: () =>
                            import(
                                /* webpackChunkName: "system" */ '@/views/system-manage/dict/index.vue'
                            ),
                        meta: {
                            name: '数据字典',
                        },
                    },
                    {
                        path: 'crowd',
                        name: 'crowd',
                        code: 'Management:SystemManage:SuitableCrowd',
                        component: () =>
                            import(
                                /* webpackChunkName: "system" */ '@/views/system-manage/crowd/index.vue'
                            ),
                        meta: {
                            name: '适用人群',
                        },
                    },
                    {
                        path: 'meal',
                        name: 'meal',
                        code: 'Management:SystemManage:MealTimesSetting',
                        component: () =>
                            import(
                                /* webpackChunkName: "system" */ '@/views/system-manage/meal/index.vue'
                            ),
                        meta: {
                            name: '餐次设置',
                        },
                    },
                    {
                        path: 'summary',
                        name: 'summary',
                        code: 'Management:SystemManage:AnalysisFoodCategorySummary',
                        component: () =>
                            import(
                                /* webpackChunkName: "system" */ '@/views/system-manage/food-summary/index.vue'
                            ),
                        meta: {
                            name: '食物分类汇总',
                        },
                    },
                    {
                        path: 'order',
                        name: 'order',
                        code: 'dingTalkRelease',
                        component: () =>
                            import(
                                /* webpackChunkName: "system" */ '@/views/system-manage/order/index.vue'
                            ),
                        meta: {
                            name: '点餐设置',
                        },
                    },
                ],
            },
            {
                path: 'analysis-measure',
                name: 'analysis-measure',
                icon: 'icon-cspshenpi-tianchong',
                code: 'Management:AnalysisMeasure',
                component: () =>
                    import(
                        /* webpackChunkName: "analysis" */ '@/views/analysis-measure/index.vue'
                    ),
                meta: {
                    name: '分析标准',
                },
            },
            {
                path: 'nutrition-label',
                name: 'nutrition-label',
                icon: 'icon-nengliang',
                code: 'Management:NutritionLabel',
                meta: {
                    name: '营养标签',
                },
                children: [
                    {
                        path: 'set',
                        name: 'set',
                        code: 'Management:NutritionLabel:LabelSetting',
                        component: () =>
                            import(
                                /* webpackChunkName: "nutrition" */ '@/views/nutrition-label/index.vue'
                            ),
                        meta: {
                            name: '标签设置',
                        },
                    },
                ],
            },
            {
                path: 'evaluation',
                name: 'evaluation',
                icon: 'icon-manyidupingjia',
                code: 'Management:Evaluation',
                meta: {
                    name: '满意度评价',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "evaluation" */ '@/views/evaluation/index.vue'
                    ),
            },
            {
                path: 'apk',
                name: 'apk',
                icon: 'icon-apkguanli',
                code: 'Management:ApkManage',
                meta: {
                    name: 'APK管理',
                },
                component: () =>
                    import(
                        /* webpackChunkName: "evaluation" */ '@/views/APK/index.vue'
                    ),
            },
        ],
    },
    {
        path: '/index',
        name: 'ThaliScreen',
        component: ThaliScreen,
    },
    {
        path: '/rate',
        name: 'RateScreen',
        component: RateScreen,
    },
    {
        path: '/school',
        name: 'SchoolScreen',
        component: SchoolScreen,
    },
    {
        path: '/school-only',
        name: 'SchoolOnlyScreen',
        component: SchoolOnlyScreen,
    },
    {
        path: '/preview',
        name: 'WeekLocalPreview',
        component: WeekLocalPreview,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
// 路由拦截 beforeEach
router.beforeEach(async (to, from, next) => {
    NProgress.start();
    next();
});
// 路由跳转结束
router.afterEach(() => {
    NProgress.done();
});
// 路由跳转错误
router.onError(() => {
    NProgress.done();
});

export default router;
